//export let api = "http://localhost:3006/api"
//export let api = "/api"
export let api = "https://library.ksaa.gov.sa/api"
